import apiClient from '@/axios/app-client';

export interface Prefecture {
  id: string;
  name: string;
}

export const prefecturesService = {
  /**
   * Get all prefectures
   * @returns List of all prefectures
   */
  async getAll(): Promise<Prefecture[]> {
    // API returns array directly, not wrapped in { prefectures: [...] }
    const response = await apiClient.get<Prefecture[]>('/v1/prefectures');
    return response.data.data;
  },
};
